// Tutorial types and interfaces

export type TutorialPage = 1 | 2 | 3 | 4 | 5 | 6;

// Tooltip-style positioning for desktop tutorial modals
export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right' | 'auto';

export interface TooltipPositionResult {
  position: TooltipPosition;
  style: {
    top?: number;
    left?: number;
    right?: number;
    bottom?: number;
  };
  pointerStyle: {
    top?: number;
    left?: number;
    right?: number;
    bottom?: number;
  };
  pointerDirection: 'up' | 'down' | 'left' | 'right';
}

export interface TutorialState {
  isActive: boolean;
  currentPage: TutorialPage;
  hasCompleted: boolean;
}

export interface TutorialContextType {
  tutorialState: TutorialState;
  startTutorial: () => void;
  nextPage: () => void;
  prevPage: () => void;
  goToPage: (page: TutorialPage) => void;
  skipTutorial: () => void;
  completeTutorial: () => void;
  resetTutorial: () => void;
}

export interface TutorialStorageData {
  completed: boolean;
  timestamp: string;
  lastPage?: TutorialPage;
}

export interface TutorialPageConfig {
  page: TutorialPage;
  title: string;
  description?: string;
  subtitle?: string;
  spotlightTargets?: string[]; // data-tutorial-id values
  arrowTargets?: Array<{
    targetId: string;
    direction: 'left' | 'right' | 'up' | 'down';
    fromSide?: 'left' | 'right' | 'top' | 'bottom';
  }>;
}

export const TUTORIAL_STORAGE_KEY = 'wallstreetle_tutorial_completed';

// Desktop tutorial has 5 pages, mobile has 6 steps
export const TOTAL_TUTORIAL_PAGES = 5; // Desktop (legacy default)
export const TOTAL_DESKTOP_TUTORIAL_PAGES = 5;
export const TOTAL_MOBILE_TUTORIAL_PAGES = 6;
